const selectors = [
  'a[href]:not([disabled])',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

export default (container) => Array.from(container.querySelectorAll(selectors))
  .filter((el) => el.offsetParent !== null || window.getComputedStyle(el).position === 'fixed');
